module.exports = __webpack_public_path__ + "img/logobew.d7caaf13.svg";